import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import _ from "lodash";
import {
  getPhenomenaTypes,
  getGroupById,
  getRadar,
} from "@futures-platform/connectors/drupal-api";
import checked from "./components/CardHeader/checked.svg";
import g1 from "./components/CardHeader/greyscale-regular@2x.png";
import trans from "./components/CardHeader/trans.svg";
import orginalTrans from "./components/CardHeader/orignalTrans.svg";
import arrow from "./components/CardHeader/arrow.svg";
import { getUserId } from "@futures-platform/connectors/session";
import { normalizeGroup } from "@futures-platform/connectors/drupal-api/normalize";

import {
  getPhenomena,
  getContentCardData,
  getPhenomenonNewsByPhenId,
  getPhenomenaStatistic,
} from "./helpers/phenomenonFetcher";
import YoutubeImageEmbed from "./components/YoutubeImageEmbed";
import LatestNewsCarousel from "./components/LatestNewsCarousel";
import Comments from "./components/Comments";
import CardHeader from "./components/CardHeader";
import BodyCard from "./components/CardBody";
import RelatedPhenomena from "./components/RelatedPhenomena";
import LatestNews from "./components/LatestNews";
import CardFooter from "./components/CardFooter";
import Links from "./components/Links";
import Rating from "./components/Rating/Rating";
import styled from "styled-components";
import ToggleSwitcher from "./components/PhenEditForm/ToggleSwitcher";
import { PhenomenonEditForm } from "./components/PhenEditForm/PhenomenonEditForm";
import {
  Modal,
  // paddingModalStyles,
} from "@futures-platform/ui";
import { PhenEditCardStyles } from "./styles";
import { DataContext } from "./store/GlobalState";
import { ACTIONS } from "./store/Actions";
import useSWR, { SWRConfig } from "swr";
// import {commentingApi} from './helpers/commentingFetcher'
// import { getUserId } from '@futures-platform/connectors/session'
import { getAllCommentsByPhenId } from "./helpers/utils";
import { votingApi } from "./helpers/fetcher";
// import styled from 'styled-components'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getDocuments } from "@futures-platform/connectors/content-service-api";
import RelatedScenarios from "./components/RelatedScenarios";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./components/LatestNews/LatestNews.module.css";
import { requestTranslation } from "@futures-platform/i18n";
import { normalisedTimeFormat } from "./helpers/helpers";
import {
  Dropdown,
  DropdownValue,
} from "./components/PhenEditForm/PhenomenonEditForm";
import ContactSupportForm from "./components/ContactSupportForm";
import Voting from "./components/Voting/Voting";
import TranslationBtn from "./components/TranslationBtn";
import TranslationDownBtn from "./components/TranslationDownBtn";
import SpotlightBtn from "./components/SpotlightBtn";
import BookmarkBtn from "./components/BookmarkBtn";
import ShareBtn from "./components/ShareBtn";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import useOnClickOutside from "./hooks/useOnClickOutside";
import { PhenomenaTagList } from "./components/PhenomenaTagList";
import {isPublicShare} from '@futures-platform/connectors/session'
const specialGroupsAllowedTranslation = [
  
]
const App = ({ gid, rid, pid, position, groupRadarId, uri }) => {
  NProgress.configure({ minimum: 0.1 });
  const mainContentCard = useRef();
  const relatedPhenOnAppRef = useRef();
  const cmtRef = useRef();
  const sharedBtnRef = useRef();
  const hostname = window?.location?.origin;
  const {
    state: { isTranslated, langForTransState, isAutoTrans, langListOpts, tags },
    dispatch,
  } = useContext(DataContext);
  const langOptionList = useMemo(() => {
    if (!!langListOpts?.length) {
      return langListOpts?.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    } else return [];
  }, [langListOpts]);
  const historyWrapperRef = useRef();
  const historyWrapper2Ref = useRef();

  const [openPhenEditCard, setOpenPhenEditCard] = useState(null);
  const [scenariosState, setscenariosState] = useState([]);
  const [langForTransTemp, setlangForTransTemp] = useState(langForTransState);

  const [iconNewsFeedSection, seticonNewsFeedSection] = useState("expand_more");
  const [historyOrignalDataState, sethistoryOrignalDataState] = useState([]);
  const [isOpenTransSettings, setisOpenTransSettings] = useState(false);
  const [isAutoTransTemp, setisAutoTransTemp] = useState(isAutoTrans);
  const [isNewsBookMarked, setisNewsBookMarked] = useState(false);
  const [isSharedModalOpened, setisSharedModalOpened] = useState(false);
  const shareWrapperRef = useRef();

  const handleChangeIconNewsFeedSection = () => {
    if (iconNewsFeedSection === "expand_more")
      seticonNewsFeedSection(() => `expand_less`);
    else {
      seticonNewsFeedSection(() => `expand_more`);
    }
  };
  NProgress.start();
  NProgress.set(0.2);
  const groupIdUsed = React.useMemo(() => {
    return groupRadarId;
  }, [groupRadarId]);

  useEffect(() => {
    dispatch({
      type: ACTIONS.GROUPRADARID,
      payload: groupIdUsed,
    });
  }, [dispatch, groupIdUsed]);

  const { data, mutate: mutateContentCard } = useSWR(
    `getAllCommentsByPhenId=${groupIdUsed}/${rid}/${pid}`,
    async () => {
      // const groups = [...new Set([0, Number(gid)])]
      try {
        const [
          phenomenon,
          phenomenonType,
          allCmtsData,
          // newsFeed,
          getPhenomenaData,
          getGroupByIdData,
          getRadarData,
          getStatus1BookmarkNews,
        ] = await Promise.all([
          getContentCardData(Number(gid) || 0, pid),
          getPhenomenaTypes(gid || 0),
          !!pid &&
            !!rid &&
            getAllCommentsByPhenId(groupIdUsed || gid, rid, pid),
          // null,
          // getNewsFeedData(gid || 0, pid),
          getPhenomena({
            phenomena: [pid],
            undefined,
            groups: [Number(gid) || 0],
          }),
          getGroupById(gid || 0),
          !!pid && !!rid && getRadar(rid),
          votingApi.getStatus1BookmarkNews(`${gid || 0}/phenomenon/${pid}`),
        ]);
        const bookmarkEntityUriSplited =
          !!getStatus1BookmarkNews?.data.length &&
          getStatus1BookmarkNews?.data[0]?.entityUri?.split("/");

        const newsIdFromEntityUriRes = !!bookmarkEntityUriSplited
          ? bookmarkEntityUriSplited[4]
          : false;

        if (!!newsIdFromEntityUriRes && newsIdFromEntityUriRes === pid) {
          setisNewsBookMarked(true);
        } else {
          setisNewsBookMarked(false);
        }
        dispatch({
          type: ACTIONS.GETRADARDATAACTION,
          payload: getRadarData,
        });

        dispatch({
          type: ACTIONS.CMTSDATA,
          payload: allCmtsData?.data,
        });

        dispatch({
          type: ACTIONS.CONTENTTYPES,
          payload: phenomenonType,
        });
        const groupNormalized =
          !!getGroupByIdData &&
          !!getGroupByIdData?.length &&
          (await Promise.all(
            getGroupByIdData?.map((group) => {
              return normalizeGroup(group);
            })
          ));

        dispatch({
          type: ACTIONS.CONTENTSETTINGS,
          payload: groupNormalized,
        });
        // const phenomenon = {
        //   data: {
        //     "id": "83f100ca-019b-4ec0-90fb-7654962dfb3b",
        //     "score": 0,
        //     "type": "phenomenon",
        //     "groups": [
        //         0
        //     ],
        //     "language": "en",
        //     "content": {
        //         "title": "Religious Fundamentalism",
        //         "short_title": "Religious Fundamentalism",
        //         "summary": "<p>Religious fundamentalism refers to a strict and uncompromising adherence to the core beliefs and doctrines of a particular religion, often accompanied by a rejection of modernity and a desire to preserve traditional values and practices. It typically involves a literal interpretation of sacred texts, a resistance to secular influences, and a strong emphasis on religious authority and orthodoxy. In the future, increasing social polarisation may lead to the rise of religious fascism and aggressive secularism that can threaten freedom of religion.</p>",
        //         "body": "<h2>Background&nbsp;</h2><p>The conceptual definitions of fundamentalism and fundamentalist beliefs are subject to academic debate; however, they are commonly understood as a mode of thought characterised by intellectual vices such as closed-mindedness, strict adherence to an ideological position, literalist interpretations of religious texts, and near-absolute certainty of the infallibility of one’s own beliefs.</p><p>As such, fundamentalism is not exclusively a religious phenomenon but can also be related to quasi-religious, religio-political, and secular ideologies, such as neo-Nazism, Islamism, and Hindu nationalism. Thus, fundamentalism should not be confused with religious ‘conservatism’, ‘traditionalism’, and ‘orthodoxy’ since it is none of these things in the strictest sense but a uniquely modern phenomenon with its origins in the late 19th and early 20th century in the Christian context as a reaction against modernist thought and its influences.</p><p>Religious fundamentalist groups and individuals often emphasise the need to ‘return’ to or ‘revive’ an idealised version of the ‘true' unadulterated ‘pure’ religious belief or praxis they believe has been lost due to internal corruption or corrosive outside influences, e.g., liberalism, secularisation, and ecumenism. Hence, there is a tendency among fundamentalist individuals and groups to reinforce an in-group identity and cohesion vis-à-vis the out-group.</p><p>Moreover, the so-called fundamentalists may subscribe to millenarianism, apocalypticism, or reactionary and countercultural ideas and beliefs, but all such groups, e.g., the Amish, are not necessarily militant but instead embrace pacifism. Nevertheless, in recent decades, fundamentalism has become associated with radical extremist groups, such as Al-Qaeda, Boko Haram, ISIS, Christian far-right, and various factions linked to the complex Sunni-Shi´a hegemony struggle.&nbsp;</p><h2>Impacts</h2><p>Religiously inspired movements with fundamentalist characteristics may continue to thrive in unstable and impoverished societies, e.g., in the African continent, where it is easier to recruit new followers and maintain an armed force capable of controlling territory. Such groups are unlikely to gain significant support in more developed and stable societies but remain on the fringe. Hence, the future success of militant organisations mainly depends on the prevalent political, social, and economic conditions.&nbsp;</p><p>Increasing social polarisation can fuel fundamentalist ideologies in response to perceived threats to religious, national, ethnic, and social class identities all over the world. Fundamentalist thought may become increasingly mainstream and inseparable from politics in Western societies, thus cementing the acquisition of political power and influencing legislation as means of waging a culture war between seemingly incompatible core beliefs and values. This may give rise to religious fascism or foster aggressive secularist attitudes that treat virtually all religious individuals and groups with extreme prejudice, jeopardising social order and religious freedom.</p><h3>Additional information</h3><ul><li>Hannah Ellis-Petersen, “What is Hindu nationalism and how does it relate to trouble in Leicester?” The Guardian. <a href=\"https://www.theguardian.com/world/2022/sep/20/what-is-hindu-nationalism-and-who-are-the-rss\" rel=\"noopener noreferrer\" target=\"_blank\">https://www.theguardian.com/world/2022/sep/20/what-is-hindu-nationalism-and-who-are-the-rss</a>&nbsp;</li><li>Elizabeth Dias, “The Far-Right Christian Quest for Power: ‘We Are Seeing Them Emboldened’”. The New York Times. <a href=\"https://www.nytimes.com/2022/07/08/us/christian-nationalism-politicians.html\" rel=\"noopener noreferrer\" target=\"_blank\">https://www.nytimes.com/2022/07/08/us/christian-nationalism-politicians.html</a>&nbsp;&nbsp;</li><li>Peels, R. (2022). On defining ‘fundamentalism’. <em>Religious Studies,</em> 1-19. DOI: <a href=\"https://www.cambridge.org/core/journals/religious-studies/article/on-defining-fundamentalism/5AAF2188C7E7414347D9C2CDA2B4335C\" rel=\"noopener noreferrer\" target=\"_blank\">10.1017/S0034412522000683</a>&nbsp;</li><li>Dr. Rik Peels &amp; Nora Kindermann. (2022). What are fundamentalist beliefs?, <em>Journal of Political Ideologies</em>, DOI: <a href=\"https://doi.org/10.1080/13569317.2022.2138294\" rel=\"noopener noreferrer\" target=\"_blank\">10.1080/13569317.2022.2138294</a></li></ul><h4>History and major changes of this phenomenon:&nbsp;&nbsp;</h4><p>Originally created in June 2023.&nbsp;</p><p>Next content review: 12/2023</p>",
        //         "type": "bf127402-abbe-42e7-b3c5-a8e46c76cfb0",
        //         "media": {
        //             "video": "https://www.youtube.com/embed/cnG-BI98-_0",
        //             "image": "",
        //             "text": "How a new Christian right is changing US politics - BBC News, BBC News"
        //         },
        //         "related_phenomena": [
        //             "eea8d3c2-5232-41ed-a1a7-3c051db06adf",
        //             "30ebe7dc-3f90-49e1-b8aa-3ccc0924ab12",
        //             "dcc16ca6-4aea-4aad-9e55-1a6077d59834",
        //             "61c2d661-e8cb-4645-b0c9-ed7ab58a2313",
        //             "61717f45-886e-4bbc-883c-07548148e8ff"
        //         ],
        //         "feed_tags": [],
        //         "time_range": {
        //             "min": 2025,
        //             "max": 2040
        //         },
        //         "links": []
        //     },
        //     "archived": false,
        //     "updated_by": 404970,
        //     "created_by": 404970,
        //     "created_at": "2023-06-08T08:57:32.218Z",
        //     "updated_at": "2023-06-08T08:57:56.674Z",
        //     "tags_fp:docs/props/has": [
        //         "fp:tags/theme/values-ethics",
        //         "fp:tags/theme/politics-policies",
        //         "fp:tags/theme/security-safety"
        //     ],
        //     "latestUpdate_v2": 1686203852.218
        // }
        // }
        return {
          phenomenon,
          phenomenonType,
          allCmtsData,
          // newsFeed,
          getPhenomenaData,
          groupNormalized,
          getRadarData,
        };
      } catch (error) {}
    }
  );

  const historyLogsState = useMemo(() => {
    return !!data?.phenomenon?.data?.content?.historyLogs?.length
      ? data?.phenomenon?.data?.content?.historyLogs
      : !!data?.phenomenon?.data?.content?.history?.length
      ? data?.phenomenon?.data?.content?.history
      : [];
  }, [data?.phenomenon?.data?.content]);

  useEffect(() => {
    const fetcher = async () => {
      if (true) {
        const [res, res1] = 
          await Promise.all([
            votingApi.getUserName(data?.phenomenon?.data?.["created_by"]),
            votingApi.getUserName(data?.phenomenon?.data?.["updated_by"]),
          ]);
        const tempDate = normalisedTimeFormat(
          data?.phenomenon?.data?.["created_at"],
          false
        );
        const tempDate1 = normalisedTimeFormat(
          data?.phenomenon?.data?.["updated_at"],
          false
        );
        const temp1 = [
          {
            isMajorUpdate: true,
            description: "",
            isCreator: true,
            editorName: res?.data?.displayName ?? "",
            isShown: true,
            date: tempDate,
            id: new Date(data?.phenomenon?.data?.["created_at"]).getTime(),
            timestamp: new Date(
              data?.phenomenon?.data?.["created_at"]
            ).getTime(),
          },
          {
            isMajorUpdate: true,
            description: "",
            isCreator: false,
            editorName: res1?.data?.displayName ?? "",
            isShown: true,
            date: tempDate1,
            id: new Date(data?.phenomenon?.data?.["updated_at"]).getTime(),
            timestamp: new Date(
              data?.phenomenon?.data?.["updated_at"]
            ).getTime(),
          },
        ]?.sort((a, b) => b?.timestamp - a?.timestamp);
        sethistoryOrignalDataState(() => temp1);
      }
    };
    if (!!data?.phenomenon?.data && !historyLogsState?.length) {
      fetcher();
    }
  }, [data?.phenomenon?.data, historyLogsState]);

  useEffect(() => {
    const fetcher = async () => {
      if (true) {
        const userId = getUserId();
        const isPublicShareVar = isPublicShare();

        const [res1, res2] = await Promise.all([
          votingApi.getUserName(userId),
          votingApi.getListLangs(),
        ]);

        dispatch({
          type: ACTIONS.LANGFORTRANSSTATE,
          payload: res1?.data?.preferredLanguage,
        });
        
        dispatch({
          type: ACTIONS.LANGLISTOPTIONS,
          payload: res2?.data || [],
        });
        
        if (!!isPublicShareVar) {
          const payload = {
            is_auto_translation: 0,
          };
            await votingApi.editPreferredTrans(userId, payload);
            dispatch({
              type: ACTIONS.ISAUTOTRANS,
              payload: 0,
            });
        } else {
          dispatch({
            type: ACTIONS.ISAUTOTRANS,
            payload: res1?.data?.isAutoTranslation,
          });
        }
      }
    };

    fetcher();
  }, []);

  const historyData = React.useMemo(() => {
    if (!historyLogsState?.length) {
      return [...historyOrignalDataState]?.sort(function (a, b) {
        return b?.timestamp - a?.timestamp;
      });
    }
    const temp = !!historyLogsState?.length
      ? [...historyLogsState]?.sort(function (a, b) {
          return b?.timestamp - a?.timestamp;
        })
      : [];
    return temp;
  }, [historyLogsState, historyOrignalDataState]);

  useEffect(() => {
    const fetcher = async () => {
      const res = await getDocuments({
        type: "scenario-card",
        ids: data?.phenomenon?.data?.content?.related_scenarios,
        fields: null,
        sortColumns: null,
      });
      const res2 = res?.sort(function (a, b) {
        return (
          data?.phenomenon?.data?.content?.related_scenarios?.indexOf(a?.id) -
          data?.phenomenon?.data?.content?.related_scenarios.indexOf(b?.id)
        );
      });
      setscenariosState(() => res2);
    };
    !!data?.phenomenon?.data?.content?.related_scenarios?.length && fetcher();
  }, [data?.phenomenon]);
  !!data && NProgress.set(0.5);

  const phenomenonData = React.useMemo(() => {
    return data?.phenomenon?.data;
  }, [data?.phenomenon?.data]);

  const langRadar = React.useMemo(() => {
    return data?.phenomenon.data?.language;
  }, [data?.phenomenon?.data?.language]);

  const phenomenonTypesData = React.useMemo(() => {
    return data?.phenomenonType;
  }, [data?.phenomenonType]);

  const phenomenonTypeData = React.useMemo(() => {
    return !!data?.phenomenonType?.length &&
      !!data?.phenomenon?.data?.content?.type
      ? data?.phenomenonType?.filter(
          (type) => type?.id === data?.phenomenon?.data?.content?.type
        )
      : [];
  }, [data?.phenomenon?.data?.content?.type, data?.phenomenonType]);

  const closeSocialBtnsHAndler = () => {
    setisSharedModalOpened(false);
  };

  const isFPEditorRole = useMemo(() => {
    const IsHaveCanEditPublic =
    !!data?.groupNormalized?.length &&
    data?.groupNormalized?.filter((gr) => {
      return gr?.canEditPublic === true;
    });
    return IsHaveCanEditPublic?.length > 0 ? true : false;
  }, [data?.groupNormalized])

  const canEditContentCard = React.useMemo(() => {
    if (!!gid && Number(gid) === 0) {
      const IsHaveCanEditPublic =
        !!data?.groupNormalized?.length &&
        data?.groupNormalized?.filter((gr) => {
          return gr?.canEditPublic === true;
        });
      return IsHaveCanEditPublic?.length > 0 ? true : false;
    } else {
      const isHaveCanEdit =
        !!data?.groupNormalized?.length &&
        data?.groupNormalized?.filter((gr) => {
          return gr?.canEdit === true;
        });
      return isHaveCanEdit?.length > 0 ? true : false;
    }
    // }, [JSON.stringify(data)])
  }, [data?.groupNormalized, gid]);

  const { data: data2 } = useSWR(
    !!data
      ? `phenNews-relatedPhen=${JSON.stringify(data)}/${JSON.stringify(
          phenomenonData
        )}`
      : null,
    async () => {
      const [phenomenonNewsRes, relatedPhenomenaRes] = await Promise.all([
        !!phenomenonData?.newsFeeds?.length &&
          getPhenomenonNewsByPhenId(
            phenomenonData?.newsFeeds?.map((feed) => feed?.id),
            [Number(gid), 0]
          ),
        !!data?.phenomenon?.data?.content?.related_phenomena?.length &&
          getPhenomena({
            phenomena: data?.phenomenon?.data?.content?.related_phenomena,
            undefined,
            groups: [0, Number(gid)],
            // , size: data?.phenomenon?.data?.content?.related_phenomena.length
          }),
        // (Number(gid) !== 0) && !!data?.getPhenomenaData?.result?.length && votingApi.getUserName(data?.getPhenomenaData?.result[0]?.updated_by)
      ]);

      return {
        phenomenonNewsRes,
        relatedPhenomenaRes,
      };
    }
  );

  const onOpenPhenEditCard = () => {
    setOpenPhenEditCard(true);
  };

  const onClosePhenEditCard = () => {
    setOpenPhenEditCard(false);
  };

  const relatedPhenomenaData = React.useMemo(() => {
    const newRelated_content =
      !!data2?.relatedPhenomenaRes?.result?.length &&
      data2?.relatedPhenomenaRes?.result?.sort(function (a, b) {
        return (
          data?.phenomenon?.data?.content?.related_phenomena?.indexOf(a?.id) -
          data?.phenomenon?.data?.content?.related_phenomena.indexOf(b?.id)
        );
      });
    const relatedContentsFiltered =
      !!data2?.relatedPhenomenaRes?.result?.length &&
      newRelated_content?.map((r_phen) => {
        const a =
          !!data?.phenomenonType?.length &&
          data?.phenomenonType?.filter(
            (type) => type.id === r_phen?.content?.type
          );

        if (
          !!a?.length &&
          !!a[0] &&
          a[0]?.style &&
          !!a[0]?.style?.color &&
          !!a[0]?.groupType
        ) {
          r_phen["color"] = a[0]?.style?.color;
          r_phen["content-type-alias"] = "undefined";
          r_phen["content-type-title"] = a[0]?.title || a[0]?.label;
        } else {
          r_phen["color"] = "none";
          r_phen["content-type-alias"] = a[0]?.alias;
          r_phen["content-type-title"] = a[0]?.title;
        }
        return r_phen;
      });

    return relatedContentsFiltered;
  }, [data, data2]);

  const phenNews = React.useMemo(() => {
    return data2?.phenomenonNewsRes;
  }, [data2]);

  const completedPhenomenon = React.useMemo(() => {
    let phenTemp = { ...phenomenonData?.content } ?? {};
    phenTemp["color"] =
      !!phenomenonData &&
      !!phenomenonTypeData &&
      !!phenomenonTypeData?.length &&
      !!phenomenonTypeData[0]?.style?.color &&
      phenomenonData?.content?.type?.includes("fp:doc-types")
        ? phenomenonTypeData[0]?.style?.color || "none"
        : "none";
    if (
      phenTemp["color"] === "none" &&
      !phenomenonTypeData?.length &&
      !!phenomenonData?.content?.type?.includes("fp:doc-types")
    ) {
      phenTemp["content-type-alias"] = "undefined";
      phenTemp["content-type-title"] = "(no type)";
    } else {
      phenTemp["content-type-alias"] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.alias;
      phenTemp["content-type-title"] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.title;
    }
    phenTemp["related-phenomena-data"] = relatedPhenomenaData
      ? relatedPhenomenaData
      : null;
    phenTemp["phen-data"] = { ...phenomenonData };
    phenTemp["phenomenonType"] = !!phenomenonTypesData && [
      ...phenomenonTypesData,
    ];
    phenTemp["links"] = !!phenomenonData?.content?.links
      ? [...phenomenonData?.content?.links]
      : null;

    // phenTemp['newsFeeds'] = newsFeed
    phenTemp["newsFeeds"] = phenomenonData?.newsFeeds;

    phenTemp["tags"] =
      data?.getPhenomenaData?.result[0]?.["tags_fp:docs/props/has"] ||
      data?.getPhenomenaData?.result[0]?.["tags"];
    phenTemp["group"] =
      !!phenomenonData?.groups?.length && phenomenonData?.groups[0];
    dispatch({
      type: ACTIONS.TAGS,
      payload: phenTemp?.["tags"],
    });
    return phenTemp;
  }, [
    phenomenonData,
    phenomenonTypeData,
    relatedPhenomenaData,
    phenomenonTypesData,
    data?.getPhenomenaData?.result,
    dispatch,
  ]);

  useEffect(() => {
    dispatch({
      type: ACTIONS.CONTENTCARDDATA,
      payload: { ...completedPhenomenon },
    });
  }, [completedPhenomenon, dispatch]);

  const ratingsOn = React.useMemo(() => {
    if (!!data?.getRadarData?.ratingsOn) {
      return data?.getRadarData?.ratingsOn;
    }
    return false;
  }, [data?.getRadarData?.ratingsOn]);

  const likingOn = React.useMemo(() => {
    if (!!data?.getRadarData?.likingOn) {
      return data?.getRadarData?.likingOn;
    }
    return false;
  }, [data?.getRadarData?.likingOn]);

  const commentsOn = React.useMemo(() => {
    if (!!data?.getRadarData?.commentsOn) {
      return data?.getRadarData?.commentsOn;
    }
    return false;
  }, [data?.getRadarData?.commentsOn]);

  const votingOn = React.useMemo(() => {
    if (!!data?.getRadarData?.votingOn) {
      return data?.getRadarData?.votingOn;
    }
    return false;
  }, [data?.getRadarData?.votingOn]);
  !!data && !!completedPhenomenon && NProgress.done(true);
  !!data && !!completedPhenomenon && NProgress.remove();
  // const history = React.useMemo(() => {
  //   return !!historyLogsState?.length
  //     ? [...historyLogsState]?.sort(function (a, b) {
  //       return a.id - b.id;
  //   })
  //     : [];
  // }, [historyLogsState]);

  const history1Ref = useRef();
  const history2Ref = useRef();
  const history3Ref = useRef();
  const history4Ref = useRef();
  const history5Ref = useRef();
  const history6Ref = useRef();

  const history1Ref1 = useRef();
  const history2Ref1 = useRef();
  const history3Ref1 = useRef();
  const history4Ref1 = useRef();
  const history5Ref1 = useRef();
  const history6Ref1 = useRef();

  const [historytranslations, sethistorytranslations] = useState(null);
  const [history1, sethistory1] = useState(null);
  const [history2, sethistory2] = useState(null);
  const [history3, sethistory3] = useState(null);
  const [history4, sethistory4] = useState(null);
  const [history5, sethistory5] = useState(null);
  const [history6, sethistory6] = useState(null);
  useOnClickOutside(shareWrapperRef, sharedBtnRef, closeSocialBtnsHAndler);

  useEffect(() => {
    const fetcher = async () => {
      const history6Temp = history6 ?? history6Ref1.current;
      const [res1, res2, res3, res4, res5, res6] = await Promise.all([
        !!history1Ref1.current &&
          history1 &&
          votingApi.translation(
            "en",
            langForTransState,
            history1 ?? history1Ref1.current
          ),
        !!history2Ref1.current &&
          history2 &&
          votingApi.translation(
            "en",
            langForTransState,
            history2 ?? history2Ref1.current
          ),
        !!history3Ref1.current &&
          history3 &&
          votingApi.translation(
            "en",
            langForTransState,
            history3 ?? history3Ref1.current
          ),
        (!!history4 || !!history4Ref1.current) &&
          votingApi.translation(
            "en",
            langForTransState,
            history4 ?? history4Ref1.current
          ),
        (!!history5 || !!history5Ref1.current) &&
          votingApi.translation(
            "en",
            langForTransState,
            history5 ?? history5Ref1.current
          ),
        !!history6Temp &&
          (await Promise.all(
            history6Temp?.map((child) => {
              if (!!child) {
                return votingApi.translation(
                  "en",
                  langForTransState,
                  child?.innerHTML
                );
              }
            })
          )),
      ]);

      sethistorytranslations(() => {
        return {
          res1,
          res2,
          res3,
          res4,
          res5,
          res6,
        };
      });
    };
    !!isTranslated && !!history1 && !!history2 && !!history3 && fetcher();
  }, [
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
    isTranslated,
    langForTransState,
  ]);

  useEffect(() => {
    if (!!historyData && !!historyData?.length) {
      if (true) {
        if (!!history1Ref.current?.innerHTML && !history1Ref1.current) {
          history1Ref1.current = history1Ref.current?.innerHTML;
        }
        if (!!history2Ref.current?.innerHTML && !history2Ref1.current) {
          history2Ref1.current = history2Ref.current?.innerHTML;
        }
        if (!!history3Ref.current?.innerHTML && !history3Ref1.current) {
          history3Ref1.current = history3Ref.current?.innerHTML;
        }
        if (!!history4Ref.current?.innerHTML && !history4Ref1.current) {
          history4Ref1.current = history4Ref.current?.innerHTML;
        }
        if (!!history6Ref.current && !history6Ref1.current) {
          const historyList = Array.from(
            document?.querySelectorAll(".firstPartHistoryRow") ?? []
          );

          //////////=>current version code
          history6Ref1.current = historyList;
        }
        // if (!!history6Ref.current?.innerHTML && !history6Ref1.current) {
        //   history6Ref1.current = history6Ref.current?.innerHTML;
        // }
        !!history1Ref1.current &&
          !history1 &&
          sethistory1(() => history1Ref1.current);
        !!history2Ref1.current &&
          !history2 &&
          sethistory2(() => history2Ref1.current);
        !!history3Ref1.current &&
          !history3 &&
          sethistory3(() => history3Ref1.current);
        !!history4Ref1.current &&
          !history4 &&
          sethistory4(() => history4Ref1.current);
        // !!history5Ref1.current &&
        //   !history5 &&
        //   sethistory5(() => history5Ref1.current);
        !!history6Ref1.current &&
          !history6 &&
          sethistory6(() => history6Ref1.current);

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD1,
        //   payload: true
        // })
      }
    }
  }, [
    isTranslated,
    historyData,
    dispatch,
    history1,
    history2,
    history3,
    history4,
    history5,
    history6,
  ]);

  const isFirstRendered = useRef(false);
  //   useEffect(() => {
  //     if (!comp7 && !!completedPhenomenon && !!comp4 && !!rid && !ratingsOn && !isFirstRendered.current) {
  //      dispatch({
  //        type: ACTIONS.GETWHOLEHTMLCARD7,
  //        payload: true
  //      })
  //     } else {
  //      if (!rid && !comp7 && !!completedPhenomenon && !!comp4) {
  //        dispatch({
  //          type: ACTIONS.GETWHOLEHTMLCARD7,
  //          payload: true
  //        })
  //      }
  //     }
  //  }, [rid, completedPhenomenon, comp7, dispatch, ratingsOn, comp4])
  //  useEffect(() => {
  //    if (!comp5 && !!completedPhenomenon && !!comp4 && !!rid && !commentsOn && !!cmtRef.current && !isFirstRendered.current) {
  //     dispatch({
  //       type: ACTIONS.GETWHOLEHTMLCARD5,
  //       payload: true
  //     })
  //    } else {
  //     if (!rid && !comp5 && !!completedPhenomenon && !!comp4 && !!cmtRef.current) {
  //       dispatch({
  //         type: ACTIONS.GETWHOLEHTMLCARD5,
  //         payload: true
  //       })
  //     }
  //    }
  // }, [rid, completedPhenomenon, comp5, dispatch, commentsOn, comp4])

  // useEffect(() => {
  //  if (comp3 && comp4 && comp5 && comp6 && comp7 && !comp8  && comp9 &&  comp10 && comp1 &&  comp2 && !isFirstRendered.current) {
  //   if (!!relatedPhenOnAppRef?.current)
  //    dispatch({
  //     type: ACTIONS.GETWHOLEHTMLCARD8,
  //     payload: true
  //   })
  //  }
  // }, [comp3, comp4, comp5, comp6, comp7, comp8, comp9, comp10, comp11, comp1, comp2, dispatch])
  const userId = getUserId();

  const isThisGroupTranslationAllowed = React.useMemo(() => {
    const temp = specialGroupsAllowedTranslation.find(group => group === Number(gid))
    return !!temp
  }, [gid]);

  useEffect(() => {
    // if (!!langForTransState &&  !!isAutoTrans && !!completedPhenomenon &&
    //   (!! comp1 || !historyData?.length)
    //   && (!!comp2 || !completedPhenomenon?.body)
    //   && (!!comp3 || !canEditContentCard)
    //   && !!comp4
    //   && !!comp5
    //   && (!!comp6 || !phenNews?.length)
    //   && (!!comp7)
    //   && (!!comp8 )
    //   && (!!comp9 || !scenariosState?.length)
    //   && (!!comp10 || !completedPhenomenon?.media?.text)
    //   // && (!!comp11 || !data?.getRadarData)
    //   && !isFirstRendered.current
    //   ) {
    //     console.log('case11111111111')
    //     dispatch({
    //       type: ACTIONS.ISTRANSLATED,
    //       payload: true
    //     })
    //     isFirstRendered.current = true
    // }
    // else
    if (
      !!langForTransState &&
      !!isAutoTrans &&
      !!completedPhenomenon &&
      !isTranslated &&
      !isFirstRendered.current &&
      (Number(gid) === 0 || gid === 0 || !!isThisGroupTranslationAllowed)
    ) {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.ISTRANSLATED,
          payload: true,
        });
      }, 2000);
      isFirstRendered.current = true;
    }
  }, [
    completedPhenomenon,
    dispatch,
    isAutoTrans,
    isTranslated,
    langForTransState,
    gid,
    isThisGroupTranslationAllowed
  ]);

  const seletecTransHandler = (e) => {
    const label = e?.target?.innerText;
    const selectedFilter = _.find(langOptionList, {
      label: label,
    });
    if (langForTransTemp === selectedFilter?.value) {
      setlangForTransTemp(() => null);
      setisAutoTransTemp(() => false);
    } else {
      setlangForTransTemp(() => selectedFilter?.value);
    }

    // dispatch({
    //   type: ACTIONS.LANGFORTRANSSTATE,
    //   payload: selectedFilter,
    // });
  };

  const setAutoTransByOnDefaultHandler = () => {
    setisAutoTransTemp(() => !isAutoTransTemp);
    // dispatch({
    //   type: ACTIONS.ISAUTOTRANS,
    //   payload: !isAutoTrans,
    // });
  };
  const cancelSetAutoTransSettingHandler = () => {
    setisOpenTransSettings(false);
    setlangForTransTemp(() => langForTransState);
    setisAutoTransTemp(() => isAutoTrans);
  };
  const doneSetAutoTransSettingHandler = async () => {
    const payload = {
      preferred_language: langForTransTemp ?? null,
      is_auto_translation: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    };

    await votingApi.editPreferredTrans(userId, payload);
    setisOpenTransSettings(false);
    dispatch({
      type: ACTIONS.LANGFORTRANSSTATE,
      payload: langForTransTemp ?? null,
    });
    dispatch({
      type: ACTIONS.ISAUTOTRANS,
      payload: !!isAutoTransTemp && !!langForTransTemp ? 1 : 0,
    });

    // When user clicks Done btn, the content of card should be translated to the target languague,
    // because the user did indicate that he/she wants to translate the card when he/she selected
    // the target lang. So when clicking done, the content card should be translated, but this case
    // is NOT the auto-translation, so should NOT set isAutoTransTemp variable and call editPreferredTrans api
    // with payload is_auto_translation = 1 to set to auto-translation => just translating the content of card.
    if (!!langForTransTemp) {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: true,
      });
    } else {
      dispatch({
        type: ACTIONS.ISTRANSLATED,
        payload: false,
      });
    }
  };

  const newsBookmarkHandler = async () => {
    if (!!isNewsBookMarked) {
      votingApi.deleteBookmarkNews(`${gid || 0}/phenomenon/${pid}`);
    } else {
      votingApi.addBookmarkNews({
        entityUri: `/bookmark/${gid || 0}/phenomenon/${pid}`,
        title: data?.phenomenon?.data?.content?.title,
      });
    }
    setisNewsBookMarked(() => !isNewsBookMarked);
    // mutateContentCard()
  };

  const shareSocialBtnsHandler = (news1, event) => {
    event.preventDefault();
    event.stopPropagation();
    // if (event && event.stopPropagation) event.stopPropagation()

    // event.stopImmediatePropagation()
    // setisOpenSocialBtns(() => !isOpenSocialBtns)
    // setnewsItem(() => news1)

    //open/close this news' modal
    setisSharedModalOpened(() => !isSharedModalOpened);
  };

  const isNotMore495pxWidth = matchMedia("(max-width: 495px)").matches;
  const isNotMore392pxWidth = matchMedia("(max-width: 392px)").matches;

  return (
    <SWRConfig value={{ provider: () => new Map() }}>
      <div ref={mainContentCard} id="content-card-wrapper">
        {!!isOpenTransSettings && (
          <Modal
            isOpen={isOpenTransSettings}
            onRequestClose={() => setisOpenTransSettings(false)}
            style={PhenEditCardStyles}
            ariaHideApp={false}
          >
            <div
              style={{
                padding: "16px",
              }}
            >
              <h3
                style={{
                  marginTop: "1rem",
                }}
              >
                Select you preferred language for translations
              </h3>
              <LangOptWRapper
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {!!langOptionList?.length &&
                  langOptionList?.map((langOpt, i) => {
                    return (
                      <LangOpt
                        key={i}
                        data-value={langOpt?.value}
                        onClick={seletecTransHandler}
                        isSelected={langForTransTemp === langOpt?.value}
                      >
                        {langOpt?.label}
                        {langForTransTemp === langOpt?.value && (
                          <EditButton
                            style={{
                              width: 12,
                            }}
                            src={checked}
                            // onClick={() => {
                            //   dispatch({
                            //     type: ACTIONS.ISTRANSLATED,
                            //     payload: false,
                            //   });
                            // }}
                          />
                        )}
                      </LangOpt>
                    );
                  })}
              </LangOptWRapper>
              {!isPublicShare() ? (
                <AutoTransWrapper>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "calc(50% - 4.6px)",
                  }}
                >
                  <h5
                    style={{
                      margin: 0,
                    }}
                  >
                    Set auto-translations on by default?
                  </h5>
                  <ToggleSwitcher
                    checked={!langForTransTemp ? false : isAutoTransTemp}
                    toggleHandler={setAutoTransByOnDefaultHandler}
                  />
                </div>
                <p
                  style={{
                    fontSize: "13px",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  If you switch this on, all content cards created by the
                  Futures Platform are automatically translated to your
                  preferred language.
                </p>
                {true && (
                  <EditButton
                    style={{
                      height: 14,
                      margin: 0,
                    }}
                    src={g1}
                  />
                )}
              </AutoTransWrapper>
              ) : null}
              
              <CTAsWrapper>
                {/* <AskForMoreLangs className="btn btn-sm btn-outline-secondary">
                ASK FOR MORE LANGUAGES...
              </AskForMoreLangs> */}
                <ContactSupportForm />
                <div>
                  <button
                    style={{
                      boxShadow: "none",
                      border: "none",
                    }}
                    className="btn btn-lg btn-plain-gray"
                    onClick={() => {
                      cancelSetAutoTransSettingHandler();
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    style={{
                      marginLeft: "16px",
                    }}
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                      doneSetAutoTransSettingHandler();
                    }}
                    type="submit"
                  >
                    DONE
                  </button>
                </div>
              </CTAsWrapper>
            </div>
          </Modal>
        )}
        {!!data && (
          <div
            className="container p_4"
            style={{
              background: "#fff",
              color: "#333",
              /* padding: 30px 40px 40px; */
              paddingLeft: "5%",
              paddingRight: "5%",
              // paddingBottom: '4.5%',
              paddingTop: "1rem",
              paddingBottom: 0,
            }}
          >
            <CardHeader
              uri={uri}
              userId={userId}
              langForTransState={langForTransState}
              isTranslated={isTranslated}
              position={position}
              gid={gid}
              rid={rid}
              pid={pid}
              phenomenon={completedPhenomenon}
              lang={langRadar}
              votingOn={votingOn}
              groupRadarId={groupRadarId}
            />

            <div
              style={{
                display: "flex",
                justifyContent:
                  ((Number(gid) === 0 || gid === 0) && langRadar === "en") ||
                  (!!isThisGroupTranslationAllowed) ||
                  (!!rid && !!votingOn)
                    ? "space-between"
                    : "flex-end",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "0.6875rem",
              }}
            >
              {(((Number(gid) === 0 || gid === 0) && langRadar === "en") 
                || !!isThisGroupTranslationAllowed) 
                && (
                <div
                  id="translation-btn-wrapper"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {(langRadar === "en" || !!isThisGroupTranslationAllowed) && (
                    <div
                      data-langtarget={langForTransState}
                      data-uri={uri}
                      id="trans-btn"
                      style={{
                        // height: '24px',
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!isTranslated) {
                          !!langForTransState
                            ? dispatch({
                                type: ACTIONS.ISTRANSLATED,
                                payload: true,
                              })
                            : setisOpenTransSettings(true);
                        } else {
                          dispatch({
                            type: ACTIONS.ISTRANSLATED,
                            payload: false,
                          });
                        }
                      }}
                    >
                      <TranslationBtn
                        isAuthed={true}
                        isNewsBookMarked={isTranslated}
                        // isNewsBookMarked={isNewsBookMarked}
                      />
                    </div>
                  )}

                  {/* {!isTranslated && langRadar === "en" && (
                <EditButton
                  id='trans-btn'
                  style={{
                    height: '24px'
                  }}
                  data-langtarget={langForTransState}
                  data-uri={uri}
                  src={trans}
                  onClick={() =>
                    !!langForTransState ?
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: true,
                    }) : setisOpenTransSettings(true)
                  }
                />
              )}
              {!!isTranslated && langRadar === "en" && (
                <EditButton
                style={{
                  height: '24px'
                }}
                  src={orginalTrans}
                  onClick={() => {
                    dispatch({
                      type: ACTIONS.ISTRANSLATED,
                      payload: false,
                    });
                  }}
                />
              )} */}
                  {(langRadar === "en" || !!isThisGroupTranslationAllowed) && (
                    <div
                      onClick={() => setisOpenTransSettings(() => true)}
                      style={{
                        marginLeft: "0.25rem",
                      }}
                    >
                      <TranslationDownBtn
                        isAuthed={true}
                        isNewsBookMarked={isOpenTransSettings}
                      />
                    </div>
                  )}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  // width: "7.25rem",
                  width: "fit-content",
                  marginTop: !!isNotMore392pxWidth ? "0.8125rem" : 0,
                }}
              >
                <div
                  onClick={(e) => {
                    window.open("/spotlight/" + pid + "?content=phenomenon");
                  }}
                >
                  <SpotlightBtn isAuthed={true} isNewsBookMarked={false} />
                </div>

                {/* <div
                  style={{
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                  onClick={(e) => {
                    window.open("/spotlight/" + pid + "?content=phenomenon");
                  }}
                >
                  <ShareBtn isAuthed={true} isNewsBookMarked={false} />
                </div> */}

                {/* <NewsSharesWrapper
                  style={{
                    position: "relative",
                  }}
                >
                  {!!isSharedModalOpened && (
                    <ShareModalWrapper ref={shareWrapperRef}>
                      <SocialSharesWrapper>
                        <SocialShare
                          id="shared-by-linkedin"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-linkedin" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <LinkedinShareButton
                            url={hostname + "/spotlight/" + pid}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-linkedin"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in LinkedIn"
                                : "Jaa LinkedInissäI"}
                            </div>
                          </LinkedinShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-twitter"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-twitter" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <TwitterShareButton
                            url={hostname + "/spotlight/" + pid}
                            title={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-twitter"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Twitter"
                                : "Jaa Twitterissä"}
                            </div>
                          </TwitterShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-facebook"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-facebook" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <FacebookShareButton
                            url={hostname + "/spotlight/" + pid}
                            quote={data?.phenomenon?.data?.content?.title}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-facebook"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share in Facebook"
                                : "Jaa Facebookissa"}
                            </div>
                          </FacebookShareButton>
                        </SocialShare>

                        <SocialShare
                          id="shared-by-email"
                          data-href={
                            "id=" +
                            pid +
                            "/title=" +
                            data?.phenomenon?.data?.content?.title +
                            "?shared-by-email" +
                            "/data_of_news" +
                            JSON.stringify(data?.phenomenon?.data)
                          }
                        >
                          <EmailShareButton
                            IsBodyHtml={true}
                            // url={hostname + '/spotlight/' + newsItem?.id}
                            url={""}
                            subject={`[Shared from FP:] ${data?.phenomenon?.data?.content?.title}`}
                            body={`Hi!

A new way to dive into the news! Click this link to open this article in the Spotlight by Futures Platform:

${hostname}/spotlight/${pid}`}
                            // className="Demo__some-network__share-button"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <EmailBtn className="af-custom-mail"></EmailBtn>
                            <div>
                              {!!data?.phenomenon?.data &&
                              data?.phenomenon?.data?.language === "en"
                                ? "Share by Email"
                                : "Jaa Sähköpostitse"}
                            </div>
                          </EmailShareButton>
                        </SocialShare>
                      </SocialSharesWrapper>
                    </ShareModalWrapper>
                  )}
                  <div
                    onClick={(event) =>
                      shareSocialBtnsHandler(data?.phenomenon?.data, event)
                    }
                  >
                    <ShareBtn
                      isAuthed={true}
                      isNewsBookMarked={isSharedModalOpened}
                    />
                  </div>
                </NewsSharesWrapper> */}

                {/* <div onClick={newsBookmarkHandler} ref={sharedBtnRef}>
                  <BookmarkBtn
                    isAuthed={true}
                    isNewsBookMarked={isNewsBookMarked}
                  />
                </div> */}
              </div>

              {!!rid && !!votingOn && (
                <div
                  className={styles.votingWrapper}
                  style={{
                    marginLeft: !!isNotMore495pxWidth ? "auto" : "unset",
                    marginTop: !!isNotMore495pxWidth ? "0.8125rem" : 0,
                    paddingBottom: "0.8125rem",
                  }}
                >
                  {!!rid && position === "left" && !!votingOn && (
                    <Voting
                      gid={gid}
                      rid={rid}
                      pid={pid}
                      groupRadarId={groupRadarId}
                    />
                  )}
                </div>
              )}
            </div>

            <YoutubeImageEmbed
              langForTransState={langForTransState}
              embedId="rokGy0huYEA"
              phenomenon={completedPhenomenon}
              isTranslated={isTranslated}
            />
            <LatestNewsCarousel
              className="latestNewsCarousel-content-card"
              lang={langRadar}
              phenNews={phenNews}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />

            {!!rid && position === "left" && !!ratingsOn && (
              <Rating
                gid={gid}
                rid={rid}
                pid={pid}
                lang={langRadar}
                getRadarData={data?.getRadarData}
                groupRadarId={groupRadarId}
                isTranslated={isTranslated}
                langForTransState={langForTransState}
              />
            )}
            <div ref={cmtRef}>
              {!!rid && position === "left" && (
                <Comments
                  gid={gid}
                  rid={rid}
                  pid={pid}
                  lang={langRadar}
                  phenomenon={completedPhenomenon}
                  commentsOn={commentsOn}
                  likingOn={likingOn}
                  isTranslated={isTranslated}
                  langForTransState={langForTransState}
                />
              )}
            </div>
            <BodyCard
              phenomenon={completedPhenomenon}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />
            {!!completedPhenomenon?.links?.length && (
              <Links phenomenon={completedPhenomenon} lang={langRadar} />
            )}
            <div ref={relatedPhenOnAppRef}>
              <RelatedPhenomena
                langForTransState={langForTransState}
                className="relatedPhenomena-content-card"
                phenomenon={completedPhenomenon}
                gid={gid}
                rid={rid}
                pid={pid}
                lang={langRadar}
                isTranslated={isTranslated}
              />
            </div>
            <RelatedScenarios
              // scenarioSetId={data?.scenarioSet?.id}
              gid={gid}
              relatedScenarios={scenariosState}
              isTranslated={isTranslated}
              langForTransState={langForTransState}
            />
            {/* <LatestNews
              className="latestNews-content-card"
              phenNews={phenNews}
              lang={langRadar}
            /> */}

            {!!tags?.length && (
              <>
                {/* <div
                  style={{
                    background: '#e8ebeb',
                    width: '100%',
                    height: '2px',
                    marginBottom: '30px',
                  }}></div> */}
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "1.5rem",
                  }}
                >
                  {/* <img
                    style={{
                      marginTop: '5px',
                      marginRight: '12px',
                    }}
                    src={tagIcon}
                  /> */}
                  <PhenomenaTagList
                    scenario={{
                      id: pid,
                      tags: !!tags?.length ? tags : [],
                    }}
                    language={data?.phenomenon?.data?.language}
                    gid={gid}
                  />
                </div>
              </>
            )}

            <div
              className="modal-form-section"
              style={{
                paddingTop: "24px",
                paddingBottom: "24px",
                marginLeft: "-5%",
                marginRight: "-5%",
                paddingLeft: "5%",
                paddingRight: "5%",
                width: "calc(110% + 4px)",
                backgroundColor: "#F6F4F7",
                position: "relative",
              }}
            >
              <HorizontalLine></HorizontalLine>
              <Dropdown
                className="dropdown-toggle d-flex align-items-center justify-content-between"
                type="button"
                data-toggle="collapse"
                data-target="#collapsenews"
                aria-expanded="true"
                style={{
                  cursor: "pointer",
                  whiteSpace: "unset",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={handleChangeIconNewsFeedSection}
              >
                <div
                  style={{
                    // maxWidth: '70%',
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {!isTranslated && (
                    <p
                      ref={history1Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    >{`${
                      historyData[0]?.isCreator
                        ? requestTranslation("Created")
                        : requestTranslation("lastModified")
                    } by`}</p>
                  )}
                  {!!isTranslated && (
                    <p
                      ref={history1Ref}
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res1?.data,
                      }}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    ></p>
                  )}

                  <p
                    style={{
                      margin: 0,
                      color: "black",
                      fontWeight: "100",
                      wordBreak: "break-word",
                      marginRight: "2.5px",
                    }}
                  >{`${
                    Number(gid) !== 0
                      ? historyData[0]?.editorName
                      : "Futures Platform"
                  }`}</p>
                  {!isTranslated && (
                    <p
                      ref={history2Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                      }}
                    >
                      on
                    </p>
                  )}
                  {!!isTranslated && (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res2?.data,
                      }}
                      ref={history2Ref}
                      style={{
                        margin: 0,
                        color: "black",
                        fontWeight: "100",
                        wordBreak: "break-word",
                        marginRight: "2.5px",
                        textTransform: "lowercase",
                      }}
                    ></p>
                  )}
                  <p
                    style={{
                      margin: 0,
                      color: "black",
                      fontWeight: "100",
                      wordBreak: "break-word",
                    }}
                  >{`${historyData[0]?.date}`}</p>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  {!isTranslated && (
                    <p
                      ref={history3Ref}
                      style={{
                        margin: 0,
                        marginRight: "4px",
                        fontWeight: "100",
                        width: "fit-content",
                      }}
                    >
                      {iconNewsFeedSection === "expand_more"
                        ? requestTranslation("ShowHistory")
                        : requestTranslation("HideHistory")}
                    </p>
                  )}
                  {!!isTranslated && (
                    <p
                      ref={history3Ref}
                      style={{
                        margin: 0,
                        marginRight: "4px",
                        fontWeight: "100",
                        width: "fit-content",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: historytranslations?.res3?.data,
                      }}
                    ></p>
                  )}
                  <i className="material-icons">{iconNewsFeedSection}</i>
                </div>
              </Dropdown>
              <div id="collapsenews" className="collapse mt-4">
                {!isTranslated && (
                  <h3 className="mb-4" ref={history4Ref}>
                    {requestTranslation("Historyandchangelog")}
                    {/* <DropdownValue></DropdownValue> */}
                  </h3>
                )}
                {!!isTranslated && (
                  <h3
                    className="mb-4"
                    ref={history4Ref}
                    dangerouslySetInnerHTML={{
                      __html: historytranslations?.res4?.data,
                    }}
                  ></h3>
                )}
                {!!historyData?.length &&
                  historyData?.map((history, i) => {
                    return (
                      <>
                        {!!history?.isShown && (
                          <div
                            key={i}
                            style={{
                              marginBottom: "16px",
                              marginLeft: "24px",
                              display: "flex",
                              flexWrap: "wrap",
                            }}
                          >
                            {!isTranslated && (
                              <p
                                ref={history6Ref}
                                className="firstPartHistoryRow"
                                style={{
                                  margin: 0,
                                  color: "#637282",
                                  marginRight: "2.5px",
                                }}
                              >{`${
                                history?.isCreator
                                  ? requestTranslation("Created")
                                  : requestTranslation("Edited")
                              } ${requestTranslation("on")} ${
                                history?.date
                              }  ${requestTranslation("by")}`}</p>
                            )}
                            {!!isTranslated && (
                              <p
                                ref={history6Ref}
                                dangerouslySetInnerHTML={{
                                  __html: historytranslations?.res6?.[i]?.data,
                                }}
                                style={{
                                  margin: 0,
                                  color: "#637282",
                                  marginRight: "2.5px",
                                }}
                              ></p>
                            )}
                            <p
                              style={{
                                margin: 0,
                                color: "#637282",
                                marginRight: "3px",
                              }}
                            >{`${
                              Number(gid) !== 0
                                ? history?.editorName
                                : "Futures Platform"
                            }`}</p>

                            <p
                              // ref={history5Ref}
                              style={{
                                margin: 0,
                                fontWeight: 500,
                              }}
                            >
                              {history?.description}
                            </p>
                          </div>
                        )}
                      </>
                    );
                  })}
              </div>
              <CardFooter
                isTranslated={isTranslated}
                langForTransState={langForTransState}
                data={data}
                lang={langRadar}
                onOpenPhenEditCard={onOpenPhenEditCard}
                canEditContentCard={canEditContentCard}
                gid={gid}
                // lastesEditor={data2?.latestEditorName?.data?.displayName}
              />
            </div>

            {!!openPhenEditCard && (
              <Modal
                isOpen={openPhenEditCard}
                onRequestClose={onClosePhenEditCard}
                style={PhenEditCardStyles}
                ariaHideApp={false}
              >
                <PhenomenonEditForm
                  // phenomenon={completedPhenomenon?.['phen-data']?.content}
                  historyData={historyData}
                  isFPEditorRole={isFPEditorRole}
                  relatedScenarios={scenariosState}
                  radar={completedPhenomenon}
                  gid={gid}
                  rid={rid}
                  pid={pid}
                  urlSWR={`getAllCommentsByPhenId=${
                    groupIdUsed || groupRadarId
                  }/${rid}/${pid}`}
                  mutateContentCard={mutateContentCard}
                  onSubmit={() => console.log("done")}
                  basePhenomenon={{}}
                  phenomenonData={phenomenonData}
                  onCancel={onClosePhenEditCard}
                />
              </Modal>
            )}
          </div>
        )}
      </div>
    </SWRConfig>
  );
};
export default App;

const HorizontalLine = styled.div`
  margin-left: calc(-5% - 4px);
  margin-right: calc(-5% - 4px);
  width: calc(100% + 8px);
  height: 2px;
  position: absolute;
  top: 0;
  background-color: #dedede;
`;
export const LangOptWRapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const LangOpt = styled.div`
  // isSelected #5ea236
  font-weight: 400;
  color: ${(props) => (!!props.isSelected ? "white" : "black")};
  background: ${(props) => (!!props.isSelected ? "#6fbf40" : "transparent")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(50% - 4.6px);
  border: 1px solid rgb(118 118 118 / 50%);
  padding: 14px;
  margin-bottom: 6px;
  cursor: pointer;
  box-sizing: border-box;
  font-size: 14px;
  font-family: L10, Roboto, "Helvetica Neue", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  &:nth-child(odd) {
    margin-right: 3px;
  }
  &:nth-child(even) {
    margin-left: 3px;
  }
  :hover {
    background: ${(props) => (!!props.isSelected ? "#5ea236" : "#aaaaaa36")};
  }
`;

export const EditButton = styled.img`
  cursor: pointer;
  margin-left: 16px;
  height: 24px;
  :hover {
    opacity: 0.8;
  }
`;
export const AutoTransWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const CTAsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const NewsSharesWrapper = styled.div`
  width: fit-content;
  height: fit-content;
`;

const ShareModalWrapper = styled.div`
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  z-index: 11111;
  position: absolute;
  width: fit-content;
  height: fit-content;
  font-size: 1rem;
  left: 0;
  background: #fafafa;
  color: #212529;
  top: 100%;
  background-clip: padding-box;
  border: 0 solid #e9e9e9;
  border-radius: 0;
  margin: 1px 0 0;
  padding: 8px 16px 8px 12px;
  padding-bottom: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const SocialSharesWrapper = styled.div`
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: column;
`;

const SocialShare = styled.div`
  margin: 8px;
  white-space: nowrap;
  overflow: hidden;
`;
const EmailBtn = styled.span`
  &::before {
    padding: 10px;
  }
  color: rgb(0, 0, 0);
`;
